export {default as TikTokLogo} from './TikTok.svg';
export {default as InstagramLogo} from './Instagram.svg';
export {default as FacebookLogo} from './Facebook.svg';
